export default __webpack_public_path__ + "static/media/chat-app.b9f7cda8.jpg";